<template>
  <div>
    <div>
      {{ $t('employment') }}: {{ employmentList }}
    </div>
    <div>
      {{ $t('schedule') }}: {{ scheduleList }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VacancyEmployment',
  props: {
    employment: {
      type: Array,
      required: true,
      default: () => [],
    },
    schedule: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    employmentList() {
      const employments = this.employment?.map(e => this.$t(`employment.${e}`)) || [];
      return employments.join(', ');
    },
    scheduleList() {
      const schedules = this.schedule?.map(e => this.$t(`schedule.${e}`)) || [];
      return schedules.join(', ');
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
employment: Employment
employment.fulltime: Full time
employment.parttime: Part time
employment.project: Contract/temporary work
employment.voluntary: Voluntary
employment.internship: Internship
schedule: Work schedule
schedule.regular: Full day
schedule.shift: Shift
schedule.flex: Flexible
schedule.remote: Remote work
schedule.watch: Fly-in/fly-out
</i18n>

<i18n locale="ru" lang="yaml">
employment: Занятость
employment.fulltime: Полная занятость
employment.parttime: Частичная занятость
employment.project: Проектная/временная работа
employment.voluntary: Волонтерство
employment.internship: Стажировка
schedule: График работы
schedule.regular: полный день
schedule.shift: сменный график
schedule.flex: гибкий график
schedule.remote: удалённая работа
schedule.watch: вахтовый метод
</i18n>
